import React from 'react'

function ProfileLegalInfo() {
  return (
    <div>
      <div className='bg-white rounded-2xl h-screen w-full p-10'>
        <div className="flex flex-col text-brand-primary">
          <h1 className="font-semibold text-[20px] pt-4">Legal Info</h1>
        </div>
        <div className='mt-5'>
        <h1 className='font-semibold text-[18px] my-2'>FAQS</h1>
        <p className='font-normal text-[16px] text-justify'>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sequi nesciunt blanditiis officia omnis eveniet corporis repellat provident officiis quasi hic, autem quibusdam cumque molestias illum cum iste suscipit quos in!</p>
        <h1 className='font-semibold text-[18px] my-2'>About Us</h1>
        <p className='font-normal text-[16px] text-justify'>bricknmix transforming online shopping into experience and aim to enrich your shopping list wisely. wide range of products powered by fast delivery and 24/7 customer service to enhance seamless shopping</p>
        <h1 className='font-semibold text-[18px] my-2'>24/7 Customer Support</h1>
        <p className='font-normal text-[16px] text-justify'>bricknmix support team is hard working 24/7 for our customers. We give high priority to troubleshoot and sort out all the complaints and issues of our customers. We will provide entire support till your face smiles.</p>
      
      </div>
      </div>
    </div>
  )
}

export default ProfileLegalInfo